export const getCurrentPageByIndex = (pageLinks, pageIndex) =>
    pageLinks.findIndex(page => page.pageIndex === pageIndex); // Set current page to actual index (position) in pageLinks array.

export const buildPagingArray = (
    { pageIndex, pageLinks, firstPage, lastPage, pageCount },
    linksBefore = 2,
    linksAfter = 3
) => {
    const totalPages = pageLinks.length;
    const pageArray = [
        {
            pageIndex: 1,
            pagination: firstPage,
            active: 1 === pageIndex
        }
    ];

    const currentPageByIndex = getCurrentPageByIndex(pageLinks, pageIndex);
    let indexStart = 1;
    let linksCountLimit = linksBefore + linksAfter + 1; // + current + page 1 (always visible)

    if (currentPageByIndex > linksBefore + 2) {
        pageArray.push({
            dotted: true
        });

        indexStart = currentPageByIndex - linksBefore;
        linksCountLimit--;
    }

    const indexMaxLimited = Math.min(indexStart + linksCountLimit, totalPages);

    if (indexMaxLimited === totalPages) {
        let itemsAfterCurrent = totalPages - currentPageByIndex;
        let canShiftBack = Math.max(linksAfter - itemsAfterCurrent, 0);
        indexStart = Math.max(indexStart - canShiftBack, 1);
    }

    for (let i = indexStart; i < indexMaxLimited; i++) {
        if (i === 1 && pageLinks[i].pageIndex !== 2) {
            pageArray.push({
                dotted: true
            });
        }
        pageArray.push({
            pagination: pageLinks[i],
            pageIndex: pageLinks[i].pageIndex,
            active: pageLinks[i].pageIndex === pageIndex
        });
    }

    if (indexMaxLimited < totalPages) {
        pageArray.push({
            dotted: true
        });

        pageArray.push({
            pagination: lastPage,
            pageIndex: pageCount
        });
    }

    return pageArray;
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/pagination/pagination-helper.js